import { useId } from 'react';
import './NewsLoader.css';

function NewsLoader({ text = 'Загрузка новостей...', className = '' }) {
  const gradientId = `newsLoaderGradient-${useId().replace(/:/g, '')}`;

  return (
    <div className={`newsLoader ${className}`.trim()}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 200 200"
        aria-hidden="true"
      >
        <radialGradient
          id={gradientId}
          cx=".66"
          fx=".66"
          cy=".3125"
          fy=".3125"
          gradientTransform="scale(1.5)"
        >
          <stop offset="0" stopColor="#EB2E23"></stop>
          <stop offset=".3" stopColor="#EB2E23" stopOpacity=".9"></stop>
          <stop offset=".6" stopColor="#EB2E23" stopOpacity=".6"></stop>
          <stop offset=".8" stopColor="#EB2E23" stopOpacity=".3"></stop>
          <stop offset="1" stopColor="#EB2E23" stopOpacity="0"></stop>
        </radialGradient>
        <circle
          fill="none"
          opacity=".2"
          stroke="#EB2E23"
          strokeWidth="15"
          strokeLinecap="round"
          cx="100"
          cy="100"
          r="70"
        ></circle>
        <circle
          className="newsLoader__spinner"
          fill="none"
          stroke={`url(#${gradientId})`}
          strokeWidth="15"
          strokeLinecap="round"
          strokeDasharray="200 1000"
          strokeDashoffset="0"
          cx="100"
          cy="100"
          r="70"
        ></circle>
      </svg>
      <p>{text}</p>
    </div>
  );
}

export default NewsLoader;
